import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { monthYear } from 'Consts/DateFormats';
import { Table } from '@facet-wealth/design';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';
import { dataAttrs } from 'Helpers/Testing';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ readonly: true }, {
    _component: () => Table.BodyCellText,
  }, {
    ordinal: 200,
  })
  .override({ name: 'createOnActivation' }, {
    _component: () => CheckboxInputLarge,
    _customProps: {
      label: '',
      helperText: '',
      ...dataAttrs('create funding on activation'),
    },
  }, {
    ordinal: 300,
  })
  .typeOverride('date', {
    _formatString: monthYear,
  });
